import React, { useCallback, useEffect } from "react";
import {
  SidebarContainer,
  IconContainer,
  SidebarContent,
  Overlay,
} from "./styled";
import { SidebarProps } from "./types";

const Sidebar: React.FC<SidebarProps> = ({
  visible,
  children,
  triggerClose,
  icon,
  className,
  width
}) => {
  const handleEscapeKey = useCallback(
    (event: KeyboardEvent) => {
      if (event.key === "Escape") {
        triggerClose();
      }
    },
    [triggerClose]
  );

  useEffect(() => {
    if (visible) {
      document.body.style.overflow = "visible";
      document.addEventListener("keydown", handleEscapeKey);
    }

    return () => {
      document.body.style.overflow = "unset";
      document.removeEventListener("keydown", handleEscapeKey);
    };
  }, [visible, handleEscapeKey]);

  return (
    <SidebarContainer
      visible={visible}
      className={className}
      onClick={(e) => e.stopPropagation()}
    >
      {icon && <IconContainer onClick={triggerClose}>{icon}</IconContainer>}
      <SidebarContent width={width} className="sidebar-content-wrapper">
        {children}
      </SidebarContent>
      <Overlay visible={visible} onClick={triggerClose} />
    </SidebarContainer>
  );
};

export default Sidebar;
